import { ITokenResponse } from '@api/models/response/ITokenResponse';
import useApiCall from 'hooks/useApiCall';
import { postLogIn } from 'api/services/user-service';
import { ILogInRequest } from 'api/models/request/ILogInRequest';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from 'constants/RoutePaths';
import { useAuthContext } from 'hooks/useAuthContext';
import { useGetMyProfilePhoto } from 'hooks/useGetMyProfilePhoto';
import { IMfaRequiredResponse } from 'api/models/response/IMfaRequiredResponse';
import { useHandleLoginSuccess } from 'hooks/useHandleLoginSuccess';

export const useLogin = () => {
    const navigate = useNavigate();
    const { callAPI, loading } = useApiCall<ILogInRequest, ITokenResponse | IMfaRequiredResponse>(postLogIn);
    const { userDispatch } = useAuthContext();
    const { getMyProfilePhotoUrl } = useGetMyProfilePhoto();
    const { handleLoginSuccess } = useHandleLoginSuccess();

    function isMfaRequiredResponse(data: any): data is IMfaRequiredResponse {
        return 'mfaRequired' in data;
    }

    function isTokenResponse(data: any): data is ITokenResponse {
        return 'token' in data && 'profile' in data;
    }

    const login = useCallback(async (request: ILogInRequest) => {
        const response = await callAPI(request);

        if (response?.status === 200 && response.data) {
            const data = response.data;

            if (isMfaRequiredResponse(data) && data.mfaRequired) {
                navigate(`${RoutePaths.MFA}?mfaId=${encodeURIComponent(data.mfaId)}`);
                return;
            }

            if (isTokenResponse(data)) {
                await handleLoginSuccess(data);
            }
        }
    }, [callAPI, navigate, userDispatch, getMyProfilePhotoUrl]);


    return { login, loginPending: loading }
}